export const OTHERS_DOMAIN_NAME = "Others";
